"use strict";

module.exports = /* @ngInject */ function(
  eikonAttributeRepository,
  sideBySideSessionRepository
) {
  var that = this;

  that.getLoginToken = function(eikonAuthToken) {
    return {
      command: "loginWithToken",
      token: eikonAuthToken
    };
  };

  that.getHandshake = function(maybeInstanceId) {
    return eikonAttributeRepository
      .getEikonLightAttributes()
      .then(function(eikonLightAttributes) {
        return {
          command: "handshake",
          apiKey: eikonLightAttributes.apiKey,
          productId: eikonLightAttributes.productId,
          instanceId: maybeInstanceId
        };
      });
  };

  that.getLaunch = function(appId, context) {
    return {
      command: "launch",
      appId: appId,
      context: { entities: [context] },
      sessionToken: sideBySideSessionRepository.getToken()
    };
  };

  that.getLaunchByUrl = function(url) {
    return {
      command: "launch",
      appId: "Internet Explorer Object",
      context: JSON.stringify({ url: url }),
      sessionToken: sideBySideSessionRepository.getToken()
    };
  };

  that.getAddSubApp = function(appName, linkType, maybeInstanceId) {
    var subApp = {
      appName: appName,
      linkType: linkType,
      subInstanceId: maybeInstanceId
    };
    return {
      command: "addSubApp",
      subApps: [subApp],
      sessionToken: sideBySideSessionRepository.getToken()
    };
  };

  that.getDelSubApp = function(subInstanceId) {
    return {
      command: "delSubApp",
      subInstanceIds: [subInstanceId],
      sessionToken: sideBySideSessionRepository.getToken()
    };
  };
  that.getSaveWorkspace = function() {
    return {
      command: "workspace",
      action: "save",
      sessionToken: sideBySideSessionRepository.getToken()
    };
  };

  that.getLoadWorkspace = function(data) {
    return {
      command: "workspace",
      action: "load",
      content: data,
      sessionToken: sideBySideSessionRepository.getToken()
    };
  };

  that.getCloseWorkspace = function() {
    return {
      command: "workspace",
      action: "close",
      sessionToken: sideBySideSessionRepository.getToken()
    };
  };

  that.getLink = function(sourceInstanceId, targetInstanceId) {
    return {
      command: "link",
      subInstanceId: sourceInstanceId,
      targetInstanceId: targetInstanceId,
      sessionToken: sideBySideSessionRepository.getToken()
    };
  };

  that.getUnlink = function(sourceInstanceId, targetInstanceId) {
    return {
      command: "unlink",
      subInstanceId: sourceInstanceId,
      targetInstanceId: targetInstanceId,
      sessionToken: sideBySideSessionRepository.getToken()
    };
  };

  that.getContextChanged = function(sourceInstanceId, entity) {
    return {
      command: "contextChanged",
      subInstanceId: sourceInstanceId,
      context: { entities: [entity] },
      sessionToken: sideBySideSessionRepository.getToken()
    };
  };

  that.getShutdown = function() {
    return {
      command: "shutdown",
      sessionToken: sideBySideSessionRepository.getToken()
    };
  };

  that.getShowMessenger = function() {
    return {
      command: "messenger",
      action: "show",
      sessionToken: sideBySideSessionRepository.getToken()
    };
  };
};



// WEBPACK FOOTER //
// ./app/infrastructure/factories/sideBySideCommandFactory.js